"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDefault = exports.ButtonStyles = exports.ButtonSizeStyles = exports.ButtonStates = exports.ButtonStylePropsArray = exports.ButtonColorArray = exports.ButtonVariantArray = exports.ButtonTagArray = exports.ButtonSizeArray = exports.ButtonTypeArray = void 0;

var _const = require("../../const");

var ButtonTypeArray = ['button', 'reset', 'submit'];
exports.ButtonTypeArray = ButtonTypeArray;
var ButtonSizeArray = ['sm', 'md'];
exports.ButtonSizeArray = ButtonSizeArray;
var ButtonTagArray = ['button', 'a', 'div', 'label'];
exports.ButtonTagArray = ButtonTagArray;
var ButtonVariantArray = ['solid', 'outlined', 'flat', 'link', 'underlined'];
exports.ButtonVariantArray = ButtonVariantArray;
var ButtonColorArray = ['primary', 'primaryDark', 'secondary', 'secondaryLight', 'gray500', 'gray700', 'gray800', 'white', 'black'];
exports.ButtonColorArray = ButtonColorArray;
var ButtonStylePropsArray = ['bg', 'color', 'border'];
exports.ButtonStylePropsArray = ButtonStylePropsArray;
var ButtonStates = ['&', '&:hover', '&:disabled'];
exports.ButtonStates = ButtonStates;
var ButtonSizeStyles = {
  sm: {
    height: 44,
    fontSize: 11,
    lineHeight: 15,
    paddingVertical: 13,
    paddingHorizontal: 15
  },
  md: {
    height: 52,
    fontSize: 11,
    lineHeight: 15,
    paddingVertical: 17,
    paddingHorizontal: 20
  }
}; // Color array values [default, hover, disabled]

exports.ButtonSizeStyles = ButtonSizeStyles;
var ButtonStyles = {
  solid: {
    primary: {
      bg: [_const.Colors.primary, _const.Colors.spanishCrimson, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.primary, _const.Colors.spanishCrimson, _const.Colors.platinum]
    },
    primaryDark: {
      bg: [_const.Colors.primaryDark, _const.Colors.claret, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.primaryDark, _const.Colors.claret, _const.Colors.platinum]
    },
    secondary: {
      bg: [_const.Colors.secondary, _const.Colors.blush, _const.Colors.platinum],
      color: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.secondary, _const.Colors.blush, _const.Colors.platinum]
    },
    secondaryLight: {
      bg: [_const.Colors.secondaryLight, _const.Colors.petal, _const.Colors.platinum],
      color: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.secondaryLight, _const.Colors.petal, _const.Colors.platinum]
    },
    gray500: {
      bg: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.platinum]
    },
    gray700: {
      bg: [_const.Colors.gray700, _const.Colors.primaryDark, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.gray700, _const.Colors.primaryDark, _const.Colors.platinum]
    },
    gray800: {
      bg: [_const.Colors.gray800, _const.Colors.white, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.platinum]
    },
    white: {
      bg: [_const.Colors.white, _const.Colors.claret, _const.Colors.platinum],
      color: [_const.Colors.claret, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.white, _const.Colors.claret, _const.Colors.platinum]
    },
    black: {
      bg: [_const.Colors.gray800, _const.Colors.white, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.platinum]
    }
  },
  outlined: {
    primary: {
      bg: [_const.Colors.transparent, _const.Colors.spanishCrimson, _const.Colors.platinum],
      color: [_const.Colors.primary, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.primary, _const.Colors.spanishCrimson, _const.Colors.platinum]
    },
    primaryDark: {
      bg: [_const.Colors.transparent, _const.Colors.claret, _const.Colors.platinum],
      color: [_const.Colors.primaryDark, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.primaryDark, _const.Colors.claret, _const.Colors.platinum]
    },
    secondary: {
      bg: [_const.Colors.transparent, _const.Colors.blush, _const.Colors.platinum],
      color: [_const.Colors.secondary, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.secondary, _const.Colors.blush, _const.Colors.platinum]
    },
    secondaryLight: {
      bg: [_const.Colors.transparent, _const.Colors.petal, _const.Colors.platinum],
      color: [_const.Colors.secondaryLight, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.secondaryLight, _const.Colors.petal, _const.Colors.platinum]
    },
    gray500: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.platinum],
      color: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.gray700],
      border: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.platinum]
    },
    gray700: {
      bg: [_const.Colors.transparent, _const.Colors.gray700, _const.Colors.platinum],
      color: [_const.Colors.gray700, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.gray700, _const.Colors.gray700, _const.Colors.platinum]
    },
    gray800: {
      bg: [_const.Colors.transparent, _const.Colors.gray800, _const.Colors.platinum],
      color: [_const.Colors.gray800, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.platinum]
    },
    white: {
      bg: [_const.Colors.transparent, _const.Colors.white, _const.Colors.platinum],
      color: [_const.Colors.white, _const.Colors.gray800, _const.Colors.gray700],
      border: [_const.Colors.white, _const.Colors.white, _const.Colors.platinum]
    },
    black: {
      bg: [_const.Colors.transparent, _const.Colors.gray800, _const.Colors.platinum],
      color: [_const.Colors.gray800, _const.Colors.white, _const.Colors.gray700],
      border: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.platinum]
    }
  },
  flat: {
    primary: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.primary, _const.Colors.primary, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    primaryDark: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.primaryDark, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    secondary: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.secondary, _const.Colors.secondaryLight, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    secondaryLight: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.secondaryLight, _const.Colors.secondary, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    gray500: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    gray700: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray700, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    gray800: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray800, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    white: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.white, _const.Colors.gray400, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    black: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    }
  },
  underlined: {
    primary: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.primary, _const.Colors.primary, _const.Colors.gray300],
      border: [_const.Colors.primary, _const.Colors.primary, _const.Colors.gray300]
    },
    primaryDark: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.primaryDark, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.primaryDark, _const.Colors.primaryDark, _const.Colors.gray300]
    },
    secondary: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.secondary, _const.Colors.secondaryLight, _const.Colors.gray300],
      border: [_const.Colors.secondary, _const.Colors.secondaryLight, _const.Colors.gray300]
    },
    secondaryLight: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.secondaryLight, _const.Colors.secondary, _const.Colors.gray300],
      border: [_const.Colors.secondaryLight, _const.Colors.secondary, _const.Colors.gray300]
    },
    gray500: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.gray300]
    },
    gray700: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray700, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.gray700, _const.Colors.primaryDark, _const.Colors.gray300]
    },
    gray800: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray800, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.gray800, _const.Colors.primaryDark, _const.Colors.gray300]
    },
    white: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.white, _const.Colors.gray400, _const.Colors.gray300],
      border: [_const.Colors.white, _const.Colors.gray400, _const.Colors.gray300]
    },
    black: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.gray300],
      border: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.gray300]
    }
  },
  link: {
    primary: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.primary, _const.Colors.primary, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    primaryDark: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.primaryDark, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    secondary: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.secondary, _const.Colors.secondaryLight, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    secondaryLight: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.secondaryLight, _const.Colors.secondary, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    gray500: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray500, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    gray700: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray700, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    gray800: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray800, _const.Colors.primaryDark, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    white: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.white, _const.Colors.gray400, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    },
    black: {
      bg: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent],
      color: [_const.Colors.gray800, _const.Colors.gray800, _const.Colors.gray300],
      border: [_const.Colors.transparent, _const.Colors.transparent, _const.Colors.transparent]
    }
  }
};
exports.ButtonStyles = ButtonStyles;
var ButtonDefault = {
  variant: 'solid',
  color: 'primary',
  type: 'button',
  measure: 'md',
  disabled: false,
  fullWidth: false,
  uppercase: true,
  shade: false
};
exports.ButtonDefault = ButtonDefault;